import React, { PureComponent } from "react";
import Icon from "@mdi/react";
import { mdiPlus, mdiMinus } from "@mdi/js";
import { Collapse } from "reactstrap";

import styles from "./styles.scss";

export interface AccordionItem {
  title: string;
  body: string;
}

export interface AccordionProps {
  title: string;
  items: AccordionItem[];
}

export interface AccordionState {
  isOpenArray: boolean[];
}

class Accordion extends PureComponent<AccordionProps, AccordionState> {
  constructor(props: AccordionProps) {
    super(props);
    const isOpenArray: boolean[] = [];
    props.items.forEach(() => {
      isOpenArray.push(false);
    });
    this.state = {
      isOpenArray,
    };
  }
  toggle = (index: number) => {
    let { isOpenArray } = this.state;
    isOpenArray = isOpenArray.map((isOpen: boolean, idx: number) => {
      if (index === idx && !isOpen) {
        return true;
      }
      return false;
    });
    this.setState({ isOpenArray });
  };
  render() {
    const { title, items } = this.props;
    const { isOpenArray } = this.state;
    return (
      <div className="rotoql-accordion">
        <div className="rotoql-accordion__title">{title}</div>
        {items.map((item: AccordionItem, index: number) => {
          return (
            <div key={index} className="rotoql-accordion__container">
              <button className="rotoql-accordion__toggle-button" onClick={() => this.toggle(index)}>
                {item.title}
                <div style={{ width: "30px" }}>
                  {isOpenArray[index] ? (
                    <Icon path={mdiMinus} size="30px" color="#262626" />
                  ) : (
                    <Icon path={mdiPlus} size="30px" color="#262626" />
                  )}
                </div>
              </button>
              <Collapse isOpen={isOpenArray[index]}>
                <div className="rotoql-accordion__content" dangerouslySetInnerHTML={{ __html: item.body }} />
              </Collapse>
            </div>
          );
        })}
        <style jsx global>
          {styles}
        </style>
      </div>
    );
  }
}

export default Accordion;
